module.exports = "images/sport_cricket.3241795cc1059a5658282caae5f1e6d2.png";